import { Group, Text } from '@mantine/core';
import { IconArrowDown, IconArrowUp, IconMinus } from '@tabler/icons-react';
import { changeTone, formatChange } from '../../helpers/atAGlance';

// Same arrows and colours as SummaryCard, so a delta reads identically wherever
// it appears on the dashboard.
const TONES = {
  up: { color: 'var(--mantine-color-success-5)', Icon: IconArrowUp },
  down: { color: 'var(--mantine-color-danger-5)', Icon: IconArrowDown },
  neutral: { color: 'var(--mantine-color-dimmed)', Icon: IconMinus },
};

/**
 * One figure's movement against the previous period: arrow, signed percentage,
 * and an optional trailing label.
 *
 * Lived in AtAGlanceTab until the Engagement and Conversion tabs were rebuilt on
 * the same pattern. Direction survives being read without colour, because the
 * arrow and the sign both carry it — the colour is confirmation, not the message.
 *
 * @param {object} props
 * @param {number} [props.value]
 * @param {number} [props.previousValue]
 * @param {string} [props.label] - e.g. "vs previous period"
 */
const ChangeIndicator = ({ value, previousValue, label }) => {
  const tone = TONES[changeTone(value, previousValue)];
  return (
    <Group gap={4} wrap="nowrap">
      <tone.Icon size={14} style={{ color: tone.color }} />
      <Text size="xs" c={tone.color}>
        {formatChange(value, previousValue)}
      </Text>
      {label && (
        <Text size="xs" c="dimmed">
          {label}
        </Text>
      )}
    </Group>
  );
};

export default ChangeIndicator;
